import { createZodDto } from "nestjs-zod/dto";
import { z } from "zod";

export const updatePasswordSchema = z.object({
  currentPassword: z.string().min(6, { message: "Current password is required." }),
  newPassword: z.string().min(6, { message: "New password must be at least 6 characters." }),
});

export class UpdatePasswordDto extends createZodDto(updatePasswordSchema) {}
